import { cn } from '@/lib/utils';
import { APP_NAME, COMPANY_NAME } from '@/lib/brand';

interface BrandMarkProps {
  className?: string;
  /** Draws the mark without its orange tile, for use on an orange surface. */
  bare?: boolean;
}

/** Vayu mark — a sun over two wind streams, on Vayu orange. */
export function BrandMark({ className, bare = false }: BrandMarkProps) {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden className={cn('h-8 w-8 shrink-0', className)}>
      {!bare && <rect width="32" height="32" rx="8" fill="#F4722E" />}
      <circle cx="20" cy="11" r="4.5" fill="#FFFFFF" />
      <path
        d="M6 17.5h14.5a3 3 0 1 0-2.6-4.5"
        stroke="#FFFFFF"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        opacity="0.95"
      />
      <path
        d="M6 22.5h17a3 3 0 1 1-2.6 4.5"
        stroke="#BCF5FD"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

interface BrandLockupProps {
  className?: string;
  /** Light text for dark surfaces (auth panel). */
  onDark?: boolean;
  showCompany?: boolean;
}

/** Mark + product name in Vayu's serif display face. */
export function BrandLockup({ className, onDark = false, showCompany = true }: BrandLockupProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <BrandMark />
      <div className="min-w-0 leading-tight">
        <p
          className={cn(
            'font-display truncate text-lg font-bold',
            onDark ? 'text-white' : 'text-foreground',
          )}
        >
          {APP_NAME}
        </p>
        {showCompany && (
          <p
            className={cn(
              'truncate text-[10px] font-semibold uppercase tracking-[0.14em]',
              onDark ? 'text-brand-sky/80' : 'text-muted-foreground',
            )}
          >
            by {COMPANY_NAME}
          </p>
        )}
      </div>
    </div>
  );
}
